import { useCallback, useRef } from 'react';

import type { DetailedHTMLProps, ImgHTMLAttributes } from 'react';

import fallbackImage from '/assets/images/no-image.jpeg';

export type ImageFallbackProps = DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
  fallbackSrc?: string;
};

export const ImageFallback = ({ alt, fallbackSrc = fallbackImage, ref, ...props }: ImageFallbackProps) => {
  const internalRef = useRef<HTMLImageElement | null>(null);

  const setRefs = useCallback(
    (node: HTMLImageElement | null) => {
      internalRef.current = node;

      if (typeof ref === 'function') {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    },
    [ref],
  );

  const handleError = useCallback(() => {
    if (!internalRef.current) {
      return;
    }

    internalRef.current.src = fallbackSrc;
  }, [fallbackSrc]);

  return <img alt={alt} {...props} ref={setRefs} onError={handleError} />;
};
